const colors = {
    red: '#eba9ae',
    blue: '#c3d8d9',
    white: '#cecece',
};

type alertColors = 'red' | 'blue' | 'white';
export const excelStyle = {
    headerStyle: {
        backgroundColor: '#eeeeee',
        borderColor: '#727272',
        alignVertical: 'center',
        fontWeight: 'bold',
        align: 'center',
        height: 18,
    },
    cellStyle: {
        borderColor: '#727272',
        align: 'center',
        alignVertical: 'center',
        width: 20,
        height: 15,
    },
    alertStyle: (color: alertColors): any => ({
        align: 'center',
        alignVertical: 'center',
        height: 10,
        borderColor: '#727272',
        color: '#666869',
        fontWeight: 'bold',
        backgroundColor: colors[color],
        fontSize: 4,
    }),
    fontSize: 8,
};
